import { Component, input } from '@angular/core';
import { UwIcon } from '../icon/uw-icon';

@Component({
  selector: 'uw-empty-state',
  standalone: true,
  imports: [UwIcon],
  template: `
    <div class="flex flex-col items-center justify-center gap-2 px-6 py-12 text-center">
      <span class="flex h-11 w-11 items-center justify-center rounded-full bg-surface-sunken text-text-muted">
        <uw-icon [name]="icon()" [size]="20" />
      </span>
      <p class="text-[13px] font-semibold text-primary">{{ title() }}</p>
      <p class="max-w-sm text-[12px] text-text-muted">{{ message() }}</p>
      <ng-content />
    </div>
  `,
})
export class UwEmptyState {
  readonly title = input('Nothing here yet');
  readonly message = input('Items will appear here when they are available.');
  readonly icon = input('inbox');
}
